export const SELECT_GIFT = 'SELECT_GIFT';
export const SAVE_GIFT_STEP = 'SAVE_GIFT_STEP';
export const RESET_GIFT_REDEEM = 'RESET_GIFT_REDEEM';
export const SELECT_DEAL = 'SELECT_DEAL';
